<template>
    <div>
        <allTitle ref="allTitle" />

        <el-dialog title="" :visible.sync="dialogVisible" width="1000px" :before-close="handleClose" center
            class="zfCode">
            <div class="lock">
                <div class="boxTop">

                    <div class="TopItem" :class="{ bgc: lineNum == 0 }" @click="getFree(0,)">
                        <div class="moneyBox">
                            <div>
                                <div class="item2">免费使用</div>
                                <div class="item">一个月</div>
                            </div>
                        </div>
                        <div class="fsize">
                            专属特权</div>
                        <div class="Zicon">
                            <div>
                                <img src="../assets/newImg5/SVG.png" alt="" style="vertical-align: middle;">
                                <span style="vertical-align: middle;">
                                    一对一专属客服
                                </span>
                            </div>
                            <div style="margin-top: 16px;">
                                <img src="../assets/newImg5/SVG (1).png" alt="" style="vertical-align: middle;">
                                <span style="vertical-align: middle;">
                                    最新行业走势
                                </span>
                            </div>
                            <div style="margin-top: 16px;">
                                <img src="../assets/newImg5/SVG (2).png" alt="" style="vertical-align: middle;">
                                <span style="vertical-align: middle;">
                                    全方位市场报价
                                </span>
                            </div>

                        </div>
                    </div>
                    <div class="TopItem" :class="{ bgc: lineNum == 1 }" @click="changeCode(1, 30, 1)">
                        <div class=" moneyBox">
                            <div>
                                <div class="item2">一个月</div>
                                <div class="item">¥30.00</div>
                            </div>
                        </div>
                        <div class="fsize">
                            专属特权</div>
                        <div class="Zicon">
                            <div>
                                <img src="../assets/newImg5/SVG.png" alt="" style="vertical-align: middle;">
                                <span style="vertical-align: middle;">
                                    一对一专属客服
                                </span>
                            </div>
                            <div style="margin-top: 16px;">
                                <img src="../assets/newImg5/SVG (1).png" alt="" style="vertical-align: middle;">
                                <span style="vertical-align: middle;">
                                    最新行业走势
                                </span>
                            </div>
                            <div style="margin-top: 16px;">
                                <img src="../assets/newImg5/SVG (2).png" alt="" style="vertical-align: middle;">
                                <span style="vertical-align: middle;">
                                    全方位市场报价
                                </span>
                            </div>

                        </div>
                    </div>
                    <div class="TopItem" :class="{ bgc: lineNum == 2 }" @click="changeCode(2, 70, 3)">
                        <div class="moneyBox">
                            <div>
                                <div class="item2">三个月</div>
                                <div class="item">¥70.00</div>
                            </div>
                        </div>
                        <div class="fsize">
                            专属特权</div>
                        <div class="Zicon">
                            <div>
                                <img src="../assets/newImg5/SVG.png" alt="" style="vertical-align: middle;">
                                <span style="vertical-align: middle;">
                                    一对一专属客服
                                </span>
                            </div>
                            <div style="margin-top: 16px;">
                                <img src="../assets/newImg5/SVG (1).png" alt="" style="vertical-align: middle;">
                                <span style="vertical-align: middle;">
                                    最新行业走势
                                </span>
                            </div>
                            <div style="margin-top: 16px;">
                                <img src="../assets/newImg5/SVG (2).png" alt="" style="vertical-align: middle;">
                                <span style="vertical-align: middle;">
                                    全方位市场报价
                                </span>
                            </div>

                        </div>
                    </div>
                    <div class="TopItem" :class="{ bgc: lineNum == 3 }" @click="changeCode(3, 120, 6)">
                        <div class="moneyBox">
                            <div>
                                <div class="item2">六个月</div>
                                <div class="item">¥120.00</div>
                            </div>
                        </div>
                        <div class="fsize">
                            专属特权</div>
                        <div class="Zicon">
                            <div>
                                <img src="../assets/newImg5/SVG.png" alt="" style="vertical-align: middle;">
                                <span style="vertical-align: middle;">
                                    一对一专属客服
                                </span>
                            </div>
                            <div style="margin-top: 16px;">
                                <img src="../assets/newImg5/SVG (1).png" alt="" style="vertical-align: middle;">
                                <span style="vertical-align: middle;">
                                    最新行业走势
                                </span>
                            </div>
                            <div style="margin-top: 16px;">
                                <img src="../assets/newImg5/SVG (2).png" alt="" style="vertical-align: middle;">
                                <span style="vertical-align: middle;">
                                    全方位市场报价
                                </span>
                            </div>

                        </div>
                    </div>
                    <div class="TopItem" :class="{ bgc: lineNum == 4 }" @click="changeCode(4, 218, 12)">
                        <div class="moneyBox">
                            <div>
                                <div class="item2">一年</div>
                                <div class="item">¥218.00</div>
                            </div>
                        </div>
                        <div class="fsize">
                            专属特权</div>
                        <div class="Zicon">
                            <div>
                                <img src="../assets/newImg5/SVG.png" alt="" style="vertical-align: middle;">
                                <span style="vertical-align: middle;">
                                    一对一专属客服
                                </span>
                            </div>
                            <div style="margin-top: 16px;">
                                <img src="../assets/newImg5/SVG (1).png" alt="" style="vertical-align: middle;">
                                <span style="vertical-align: middle;">
                                    最新行业走势
                                </span>
                            </div>
                            <div style="margin-top: 16px;">
                                <img src="../assets/newImg5/SVG (2).png" alt="" style="vertical-align: middle;">
                                <span style="vertical-align: middle;">
                                    全方位市场报价
                                </span>
                            </div>

                        </div>
                    </div>
                </div>
                <div class="boxBottom">
                    <div class="publichMoney">
                        <div> <img src="../assets/newImg5/二维码-公众号 1.svg" alt="">
                        </div>
                        <div style="margin-top: 30px;margin-left: 30px;">对公转账请添加客服专员小周进行操作</div>
                    </div>
                    <div class="wxMoney">
                        <div ref="qrcode" id="qrcode-container">
                        </div>
                        <div v-show="!ifShow" style="width: 120px;height: 120px;"></div>

                        <div style="margin-top: 20px;margin-left: 30px;text-align: center;">
                            <div>
                                <img src="../assets/newImg2/Vector@1x (8).png" alt="" style="vertical-align: middle;">
                                <span style="vertical-align: middle;margin-left: 10px;">微信扫码支付</span>
                            </div>
                            <div style="font-size: 32px;margin-top: 10px;">￥{{ money }}</div>
                        </div>
                    </div>
                </div>
                <!-- <div class="right">
                    <div class="rightTop">
                        <div> <img src="../assets/newImg5/二维码-公众号 1.svg" alt="">
                        </div>
                        <div style="margin-top: 30px;margin-left: 30px;">对公转账请添加客服专员小周进行操作</div>
                    </div>
                    <div class="rightBottom">
                        <div ref="qrcode" id="qrcode-container">
                        </div>
                        <div v-show="!ifShow" style="width: 120px;height: 120px;"></div>

                        <div style="margin-top: 20px;margin-left: 30px;text-align: center;">
                            <div>
                                <img src="../assets/newImg2/Vector@1x (8).png" alt="" style="vertical-align: middle;">
                                <span style="vertical-align: middle;margin-left: 10px;">微信扫码支付</span>
                            </div>
                            <div style="font-size: 32px;margin-top: 10px;">￥238.00</div>
                        </div>
                    </div>
                </div> -->
            </div>
            <!-- <div style="width: 100%;display: flex;justify-content: center;">
                <img src="../assets/newImg5/lock.png" alt="" style="margin: auto;">

            </div>
            <div style="text-align: center;font-weight: 700;margin-top: 20px;">您尚未订阅此数据查看权限</div>
            <div style="text-align: center;margin-top: 20px;margin-bottom: 30px;">订阅请致电您的专属客服:13790921868(王志)</div> -->


        </el-dialog>
    </div>
</template>

<script>
import { categoryNative, getCategoryStatusByOrderSn, getUFCLogByUserId, addCategoryOrder } from "@/api/user"
import QRCode from 'qrcodejs2';

export default {
    data() {
        return {
            dialogVisible: false,
            timer: null,
            ifShow: false,
            lineNum: 0,
            cat_one: null,
            money: 30,
            is_free: null,
        }
    },
    methods: {

        titleShow(msg) {
            this.$refs.allTitle.msg = msg
            this.$refs.allTitle.routerPath = null;
            this.$refs.allTitle.dialogVisible = true;
        },
        getFree(status) {
            if (this.is_free == 1) {
                return this.titleShow('已开通过免费订阅服务，不可重复申请')
            }
            this.$confirm('是否确认开通免费订阅一个月（每一用户同一分类仅限免费订阅一次）?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                // type: 'warning'
            }).then(() => {
                addCategoryOrder({
                    term: 1,
                    cat_one: this.cat_one,
                    cat_two: null,
                    cat_three: null,
                    order_description: '免费订阅一个月'
                }).then((res) => {
                    if (res.data.code == 200) {
                        clearInterval(this.timer)
                        this.dialogVisible = false
                        this.titleShow('免费订阅开通成功')
                        this.$refs.qrcode.innerHTML = '';
                        this.$bus.$emit("zfSuccess", {
                        });


                    } else {
                        clearInterval(this.timer)
                        this.dialogVisible = false
                        this.titleShow('操作失败')
                        this.$refs.qrcode.innerHTML = '';

                    }
                })
                // this.$message({
                //     type: 'success',
                //     message: '删除成功!'
                // });
            }).catch(() => {
                // this.$message({
                //     type: 'info',
                //     message: '已取消'
                // });
            });
        },
        handleClose() {
            if (!this.ifShow) {
                return
            }
            this.dialogVisible = false
            clearInterval(this.timer)
            console.log('清除定时器了。');

            const container = document.getElementById('qrcode-container');
            container.innerHTML = ''; // 清空容器 
            this.ifShow = false

        },

        getCode(cat_one,) {
            getUFCLogByUserId({ cat_one: cat_one }).then((res) => {
                this.is_free = res.data.data.is_free
            })
            this.cat_one = cat_one
            this.lineNum = 1
            this.dialogVisible = true
            let param = {
                term: 1,
                cat_one: cat_one,
                cat_two: null,
                cat_three: null,
                total_amount: 30,
                order_description: '用户开通'
            }
            categoryNative(param).then((res) => {

                new QRCode(this.$refs.qrcode, {
                    text: res.data.data.codeUrl,
                    width: 120,
                    height: 120
                });
                this.timer = setInterval(() => {
                    getCategoryStatusByOrderSn({ orderNo: res.data.data.orderSn }).then((res) => {
                        console.log(res, 'resppp');

                        if (res.data.code == 200) {
                            this.dialogVisible = false
                            clearInterval(this.timer)
                            this.titleShow('支付成功')
                            this.$bus.$emit("zfSuccess", {
                            });

                        } else if (res.data.code == 4011) {
                            this.titleShow('支付失败')
                            this.dialogVisible = false
                            clearInterval(this.timer)

                        }

                    })
                }, 3000);
                this.ifShow = true

            })
        },
        changeCode(status, money, month) {
            const loading = this.$loading({
                lock: true,
                text: '',
                spinner: 'el-icon-loading',

                background: 'rgba(255, 255, 255, 0.2)'
            });
            this.$refs.qrcode.innerHTML = '';
            this.money = money
            console.log(status, money, month, 'status, money, month');
            clearInterval(this.timer)
            this.lineNum = status
            this.dialogVisible = true

            let param = {
                term: month,
                cat_one: this.cat_one,
                cat_two: null,
                cat_three: null,
                total_amount: money,
                order_description: '用户开通'
            }
            categoryNative(param).then((res) => {
                loading.close()
                this.$refs.qrcode.innerHTML = '';
                new QRCode(this.$refs.qrcode, {
                    text: res.data.data.codeUrl,
                    width: 120,
                    height: 120
                });
                this.timer = setInterval(() => {
                    getCategoryStatusByOrderSn({ orderNo: res.data.data.orderSn }).then((res) => {
                        console.log(res, 'resppp');

                        if (res.data.code == 200) {
                            this.dialogVisible = false
                            clearInterval(this.timer)
                            this.titleShow('支付成功')
                            this.$bus.$emit("zfSuccess", {
                            });

                        } else if (res.data.code == 4011) {
                            this.titleShow('支付失败')
                            this.dialogVisible = false
                            clearInterval(this.timer)
                        }
                    })
                }, 3000);
                this.ifShow = true

            })
        }
    },
    created() { },
    mounted() {
    }
}
</script>

<style lang=scss scoped>
::v-deep .zfCode .el-dialog {
    background-color: #3577E8;
}

.bgc {
    border: 1px solid pink;
}

::v-deep .zfCode .el-dialog--center .el-dialog__body {
    padding: 40px 20px 30px
}

::v-deep .zfCode .el-dialog__header {
    padding: 0px !important;
}

.lock {
    height: 570px;
    width: 100%;
    background-color: #3577E8;
    // display: flex;
    box-sizing: border-box;

    .boxTop {
        width: 100%;
        height: 65%;
        display: flex;
        justify-content: space-around;
        // background-color: pink;

        .leftTop {
            width: 100%;
            height: 50%;
            text-align: center;
            color: white;
            font-size: 24px;
            display: flex;
            flex-direction: column;
            // justify-content: center;
            align-items: center;
        }

        .TopItem {
            width: 19%;
            height: 100%;
            background-color: rgb(74, 133, 234);
            color: white;
            font-size: 14px;
            border-radius: 10px;
            box-sizing: border-box;

            .moneyBox {
                width: 100%;
                height: 40%;
                text-align: center;
                display: flex;
                flex-wrap: wrap;
                align-items: center;

                justify-content: center;
                gap: 0px;

                .item {
                    width: 100%;
                    font-size: 22px;
                    font-weight: 700;
                    margin-top: 8px;
                }

                .item2 {
                    width: 100%;
                    font-size: 22px;
                    font-weight: 700;
                    font-size: 22px;
                }
            }

            .fsize {
                padding: 20px 0px 10px;
                width: 80%;
                margin: auto;
                font-weight: 600;
                border-bottom: 1px solid white;
                box-sizing: border-box;
            }

            .Zicon {
                width: 80%;
                margin: auto;
                // display: flex;
                // flex-wrap: wrap;
                margin-top: 12px;
            }
        }
    }

    .boxBottom {
        width: 100%;
        height: 35%;
        margin-top: 15px;
        display: flex;
        justify-content: space-around;

        .publichMoney {
            width: 48%;
            height: 100%;
            background-color: rgb(74, 133, 234);
            color: white;
            font-size: 14px;
            border-radius: 10px;
            display: flex;
            padding: 30px 60px;
            box-sizing: border-box;
        }

        .wxMoney {
            width: 48%;
            height: 100%;
            background-color: rgb(74, 133, 234);
            color: white;
            font-size: 14px;
            border-radius: 10px;
            padding: 30px 80px;
            box-sizing: border-box;
            display: flex;
        }
    }

    .right {
        width: 50%;
        height: 100%;

        .rightTop {
            width: 98%;
            height: 46%;
            background-color: rgb(74, 133, 234);
            color: white;
            font-size: 14px;
            border-radius: 10px;
            display: flex;
            padding: 30px 20px;
            box-sizing: border-box;
        }

        .rightBottom {
            margin-top: 16px;
            width: 98%;
            height: 49.5%;
            background-color: rgb(74, 133, 234);
            color: white;
            font-size: 14px;
            border-radius: 10px;
            padding: 30px 20px;
            box-sizing: border-box;
            display: flex;
        }
    }
}
</style>